import * as React from 'react';
import { List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import TabContent from 'src/layout/TabContent';
import { todayString } from 'src/utils/dates';
var TaskDetailList = function (_a) {
    var task = _a.task;
    return (React.createElement(TabContent, null,
        React.createElement(List, null,
            React.createElement(ListItem, { primaryText: "V\u00E9grehajt\u00F3", secondaryText: "" + task.userName }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "R\u00F6gz\u00EDt\u0151", secondaryText: "" + task.insertUser }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Felel\u0151s", secondaryText: "" + (task.responsible || '-') }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "V\u00E1llalt hat\u00E1rid\u0151", secondaryText: !task.deadline ? '-' : todayString(new Date(task.deadline)) }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "M\u00F3dos\u00EDtott hat\u00E1rid\u0151", secondaryText: !task.modifiedDeadline ? '-' : todayString(new Date(task.modifiedDeadline)) }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Tervezett kezd\u00E9s", secondaryText: !task.plannedStart ? '-' : todayString(new Date(task.plannedStart)) }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Tervezett befejez\u00E9s", secondaryText: !task.plannedEnd ? '-' : todayString(new Date(task.plannedEnd)) }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Partner", secondaryText: task.partnerName }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Projekt", secondaryText: task.project }),
            React.createElement(Divider, null),
            !task.projectCode ? null : (React.createElement(React.Fragment, null,
                React.createElement(ListItem, { primaryText: "Projekt k\u00F3d", secondaryText: "" + task.projectCode }),
                React.createElement(Divider, null))),
            !task.offerCode ? null : (React.createElement(React.Fragment, null,
                React.createElement(ListItem, { primaryText: "Aj\u00E1nlat", secondaryText: "" + task.offerCode }),
                React.createElement(Divider, null))),
            !task.calculation ? null : (React.createElement(React.Fragment, null,
                React.createElement(ListItem, { primaryText: "Kalkul\u00E1ci\u00F3", secondaryText: "" + task.calculation }),
                React.createElement(Divider, null))),
            React.createElement(ListItem, { primaryText: "\u00DCtem", secondaryText: task.stepName }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "T\u00EDpus", secondaryText: task.taskType }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Fejleszt\u00E9si m\u00F3d", secondaryText: task.developmentMode }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Kompetencia", secondaryText: task.competency }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Term\u00E9k", secondaryText: task.product }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Term\u00E9k azonos\u00EDt\u00F3", secondaryText: task.productID }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Cikksz\u00E1m", secondaryText: task.productCode }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "K\u00FCls\u0151 k\u00F3d (rajzsz\u00E1m)", secondaryText: task.externalCode || '-' }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Megjegyz\u00E9s", secondaryText: task.note || '-' }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Priorit\u00E1s", secondaryText: task.ticketPriority }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Besorol\u00E1s", secondaryText: task.ticketClass }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Ticket t\u00EDpus", secondaryText: task.ticketType }),
            React.createElement(Divider, null),
            React.createElement(ListItem, { primaryText: "Ticket alt\u00EDpus", secondaryText: task.taskSubType }),
            React.createElement(Divider, null),
            !task.tagCloud ? null : (React.createElement(ListItem, { primaryText: "C\u00EDmkefelh\u0151", secondaryText: task.tagCloud })))));
};
export default TaskDetailList;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDetailList.tsx
// module id = 740
// module chunks = 0